import React from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  listFieldOneLine: {
    borderBottom: '1px dotted #ddd',
    marginBottom: theme.spacing(1),
    justifyContent: 'space-between',
    // flexGrow: 1,
    marginRight: '8px',
    minWidth: 200,
    flexDirection: 'row'
  },
  listField: {
    [theme.breakpoints.down('sm')]: {
      borderBottom: '1px dotted #ddd',
      marginBottom: theme.spacing(1),
      justifyContent: 'space-between',
      minWidth: 200,
      flexDirection: 'row'
    },
    flex: 1,
    flexDirection: 'column'
  },
  titleOneLine: {
    fontSize: `${theme.spacing(2)-2}px`,
    alignSelf: 'flex-end',
    marginBottom: '-2px'
  },
  valueOneLine: {
    fontWeight: 500,
    fontSize: `${theme.spacing(2)}px`,
    alignSelf: 'flex-end',
    textAlign: 'right',
    marginLeft: theme.spacing(2),
    marginBottom: '-2px'
  },
  title: {
    fontSize: `${theme.spacing(2)-2}px`,
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-end',
      marginBottom: '-2px'
    }
  },
  value: {
    fontWeight: 500,
    fontSize: `${theme.spacing(2)}px`,
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'flex-end',
      textAlign: 'right',
      marginLeft: theme.spacing(2),
      marginBottom: '-2px'
    }
  }
}))

function ListField({ title, value, oneLine = false, emptyMask = '-' }) {
  const classes = useStyles()
  return (
    <Box className={oneLine ? classes.listFieldOneLine : classes.listField} display='flex'>
      <div className={oneLine ? classes.titleOneLine : classes.title}>{title}</div>
      <div className={oneLine ? classes.valueOneLine : classes.value}>{value ? value : emptyMask}</div>
    </Box>
  )
}

export default ListField
